import * as React from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { Box, TextInput, Group, Button, NumberInput, Textarea, Switch } from '@mantine/core'
import { isNotEmpty, useForm } from "@mantine/form";
import axios from 'axios';
import type { IResponse } from "../../types/api";
import { showMessage } from "../../lib/notification";
import { CLIENT_ROUTE, API_ROUTE, CLIENT_TITLE } from "./constants";
import { ISubscription } from "./types";
import Page from "../../components/layout/Page";
import { useFormStyles } from "../../styles/form";

interface FormValues extends Pick<ISubscription, 'title' | 'description' | 'durationInDays' | 'priceText' | 'price' | 'order' | 'isFeatured' | 'isActive' | 'applePriceText' | 'appleSKU' | 'googlePriceText' | 'googleSKU'> {

}

const EditSubscription = () => {

    const { state: id = null } = useLocation();

    const { classes } = useFormStyles();
    const navigate = useNavigate();

    const form = useForm<FormValues>({
        initialValues: {
            description: "",
            durationInDays: 0,
            isActive: false,
            isFeatured: false,
            order: 0,
            price: 0,
            priceText: "",
            title: "",
            appleSKU: '',
            applePriceText: '',
            googleSKU: '',
            googlePriceText: ''
        },
        validate: {
            title: isNotEmpty('Нэр оруулна уу'),
            durationInDays: isNotEmpty('Хоног оруулна уу'),
            price: isNotEmpty('Төлөх дүн оруулна уу'),
            priceText: isNotEmpty('Үнэ текст оруулна уу'),
            appleSKU: isNotEmpty('Apple SKU оруулна уу'),
            googlePriceText: isNotEmpty('Үнэ текст оруулна уу'),
            googleSKU: isNotEmpty('Google SKU оруулна уу'),
        },
    });

    React.useEffect(() => {
        const fetchData = async () => {
            const { data } = await axios.get<IResponse<ISubscription>>(`${API_ROUTE}/${id}`);
            form.setValues(data.result);
            form.resetDirty();
        }
        void fetchData();
    }, []);

    const handleSubmit = async (values: typeof form.values) => {
        const { data } = await axios.post<IResponse<any>>(`${API_ROUTE}/${id}`, values);
        if (data.statusCode === 200) {
            navigate(CLIENT_ROUTE);
            showMessage('Амжилттай', 'green')
        } else {
            showMessage('Алдаа гарлаа')
        }
    }

    return (
        <Page>
            <Page.Header title={`${CLIENT_TITLE} засах`} backRoute={CLIENT_ROUTE}/>
            <Page.Body>
                <Box sx={{ maxWidth: 500 }} mx="auto">

                    <form onSubmit={form.onSubmit(handleSubmit)} className={classes.form}>
                        <TextInput
                            withAsterisk
                            label="Нэр"
                            placeholder="Нэр оруулна уу"
                            {...form.getInputProps('title')}
                        />

                        <TextInput
                            withAsterisk
                            label="Apple SKU"
                            placeholder="Apple SKU оруулна уу"
                            {...form.getInputProps('appleSKU')}
                        />

                        <TextInput
                            label="Apple үнийн текст"
                            placeholder="Apple үнийн текст оруулна уу"
                            {...form.getInputProps('applePriceText')}
                        />

                        <TextInput
                            withAsterisk
                            label="Google SKU"
                            placeholder="Google SKU оруулна уу"
                            {...form.getInputProps('googleSKU')}
                        />

                        <TextInput
                            label="Google үнийн текст"
                            placeholder="Google үнийн текст оруулна уу"
                            {...form.getInputProps('googlePriceText')}
                        />

                        <Textarea
                            label="Тайлбар"
                            placeholder="Тайлбар оруулна уу"
                            {...form.getInputProps('description')}
                        />

                        <NumberInput
                            withAsterisk
                            label="Хоног"
                            placeholder="Хоног оруулна уу"
                            {...form.getInputProps('durationInDays')}
                        />

                        <TextInput
                            withAsterisk
                            label="Үнэ текст"
                            placeholder="Үнэ текст оруулна уу"
                            {...form.getInputProps('priceText')}
                        />

                        <NumberInput
                            withAsterisk
                            hideControls
                            label="Үнэ"
                            placeholder="Үнэ оруулна уу"
                            {...form.getInputProps('price')}
                        />

                        <NumberInput
                            label="Дараалал"
                            placeholder="Дараалал оруулна уу"
                            {...form.getInputProps('order')}
                        />

                        <Switch
                            label="Онцолсон эсэх"
                            {...form.getInputProps('isFeatured', { type: 'checkbox' })}
                        />

                        <Switch
                            label="Идэвхтэй эсэх"
                            {...form.getInputProps('isActive', { type: 'checkbox' })}
                        />
                    </form>
                </Box>
            </Page.Body>
            <Page.Footer>
                <Group position="right" mt="md">
                    <Button color='color-secondary' onClick={() => form.onSubmit(handleSubmit)()}>Хадгалах</Button>
                </Group>
            </Page.Footer>
        </Page>
    );
};

export default EditSubscription;